// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const environment = {
  production: false,
  theme:'teal-light',
  firebase: {
    apiKey: "AIzaSyB9rT1lq5WdfvvDNdmXfvPr1ABU4CRbwQg",
    authDomain: "tigelacheia-bdc9a.firebaseapp.com",
    databaseURL: "https://tigelacheia-bdc9a.firebaseio.com",
    projectId: "tigelacheia-bdc9a",
    storageBucket: "tigelacheia-bdc9a.appspot.com",
    messagingSenderId: "657002134595"
    },  
  geocodeUrl: 'https://maps.google.com/maps/api/geocode/json?address=${ender}&sensor=false&key=AIzaSyBZPzEgwY2uLZsvKL4idTWyFZezG66Dr20',
  cloudUrl: 'https://us-central1-tigelacheia-bdc9a.cloudfunctions.net',
  token:'123456',  
  db_prefix: 'nc-',
  site: {
    nome: 'TigelaCheia',
    logo: 'TC'
  }

  ,downloads:[
    {titulo:'Android App',
     url:'https://play.google.com/store/apps/details?id=tigelacheia.storeware.com'
    },
    { titulo:'Powered by',
      url:'http://storeware.com.br'
    }
  ]

};
